import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/CaretUp.tsx
const CaretUpIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "m17 14-5-6-5 6h10Z",
		fill: props.fill || "currentColor"
	})
}));
export { CaretUpIcon };
